// @flow
import { all } from "redux-saga/effects";

import layoutSaga from "./layout/saga";

/**
 * Función para configurar las sagas de Redux
 *
 * @returns {void}
 */
export default function* rootSaga() {
  yield all([layoutSaga()]);
}
